window.addEventListener("load",function(){
  $(".media-width-text-showMore").click(function() {
    $(this).parent().find(".media-width-text-new").toggleClass("open")
    $(this).hide()
  })
  $(".custom-tab-item").click(function() {
    if (!$(this).hasClass("active")) {
    let index = $(this).index()
      $(this).siblings().removeClass("active")
      $(this).addClass("active")
      $(this).parents(".custom-tab-section").find(".custom-product-container").removeClass("active")
      $(this).parents(".custom-tab-section").find(".custom-product-container").eq(index).addClass("active")
    }
  })
  if (document.documentElement.clientWidth > 750) {
    $(".corporate-culture-item").mouseenter(function() {
      if (!$(this).hasClass("active")) {
        $(this).siblings().removeClass("active")
        $(this).addClass("active")
      }
    })
  }
})